export enum AuthBroadcastMessageState {
	signIn = 'signIn',
	signOut = 'signOut'
}

export interface AuthBroadcastChannelMessage {
	type: AuthBroadcastMessageState
}

export const AUTH_BRODCAST_CHANNEL_KEY = 'auth-channel'
